const state = {};

export default state;



// WEBPACK FOOTER //
// ./scripts/sky-reveal/store/state.js